import { FC } from 'react';
import { times } from 'lodash';

import { Icon } from '@/components/icon';
import { Link } from '@/components/link';
import type { PaginationMeta } from '@/lib/types';

type PaginationProps = PaginationMeta & {
  basePath: string;
};

const Pagination: FC<PaginationProps> = ({ currentPage, totalPages, nextPage, prevPage, basePath }) => {
  if (totalPages <= 1) {
    return null;
  }

  const getPagePath = (pageNumber: number) => (pageNumber === 1 ? basePath : `${basePath}/page/${pageNumber}`);

  return (
    <div className="component col-12">
      <div className="component-content">
        <nav className="pagination">
          <ul className="pagination-list">
            <li className="pagination-list-item is-prev">
              {prevPage ? (
                <Link className="pagination-link" href={getPagePath(prevPage)}>
                  <Icon name="chevron-left" />
                </Link>
              ) : (
                <span className="pagination-link is-disabled">
                  <Icon name="chevron-left" />
                </span>
              )}
            </li>
            {times(totalPages, (index) => {
              const page = index + 1;
              const isActive = page === currentPage;

              return (
                <li key={`${basePath}-${page}`} className="pagination-list-item is-number">
                  {isActive ? (
                    <span className="pagination-link is-active">{page}</span>
                  ) : (
                    <Link className="pagination-link" href={getPagePath(page)}>
                      {page}
                    </Link>
                  )}
                </li>
              );
            })}
            <li className="pagination-list-item is-next">
              {nextPage ? (
                <Link className="pagination-link" href={getPagePath(nextPage)}>
                  <Icon name="chevron-right" />
                </Link>
              ) : (
                <span className="pagination-link is-disabled">
                  <Icon name="chevron-right" />
                </span>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export { Pagination };
